import { api } from 'common';

import { RepeatBlockFormFields } from './FormFields';
import { RepeatBlockDocumentationMarkdown } from './documentation';
import type { BlockConfigProps } from '../../types';
import { getSubFlowBlockDefaultConfig } from '../SubFlow/v2/constants';

export const repeatConfig: BlockConfigProps<api.FlowDefinition.RepeatBlock['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'repeat',
  defaultConfig: {
    subFlow: getSubFlowBlockDefaultConfig(),
    iterationStepDuration: {
      value: '0',
      units: api.FlowDefinition.DurationUnits.Seconds,
    },
    maximumIterations: 100,
    untilConditionScript: 'index === 2',
  },
  configFields: {
    schema: api.FlowDefinition.RepeatBlockConfigSchema,
    FormFields: RepeatBlockFormFields,
  },
  documentationMarkdown: RepeatBlockDocumentationMarkdown,
};
